// @flow
import type { HistoryBlockerObject } from '../types'

import { abTest20210618_16324Blocker } from './ab-test-20210618-16324-blocker'

/**
 * Array of history global blockers that cannot be linked and placed in any of
 * the modules
 */
export const historyBlockers: HistoryBlockerObject[] = [abTest20210618_16324Blocker]
